export default __webpack_public_path__ + "static/media/coder-img.d46a24b9.jpg";